import { Col, Row } from 'react-bootstrap';
import ColumnsChart from '../../../../components/ApexCharts/ColumnsChart';
import SingleColumnCustomLegend from '../../../../components/ApexCharts/CustomLegends/SingleColumnCustomLegend';
import Blockquote from '../../../../components/Blockquote';
import { formatPrice } from '../../../../utils/utils';

const compensationData = {
  chart: {
    stacked: true,
    toolbar: {
      show: false,
    },
    zoom: {
      enabled: false,
    },
  },
  colors: ['#FFB70F', '#CCDB00', '#78B800', '#0C9C8E'],
  series: [
    {
      name: 'Tuition Assistance',
      data: [1500],
    },
    {
      name: 'Performance Excellence Program Amount',
      data: [4200],
    },
    {
      name: 'Bonus',
      data: [5000],
    },
    {
      name: 'Benefit Salary',
      data: [84372],
    },
  ],


  dataLabels: {
    enabled: false,
  },
  fill: {
    opacity: 1,
  },
  legend: {
    show: false,
  },
  plotOptions: {
    bar: {
      horizontal: false,
    },
  },

  // Appply this states configuration to disable hover state.
  // It would be strange to have only one column on the chart, that flickers on hover.
  states: {
    hover: {
      filter: {
        type: 'none',
      },
    },
  },
  tooltip: {
    enabled: false,
  },
  xaxis: {
    categories:[0, 1],
    overwriteCategories: ['2021 Year'],
    tickAmount: 1,

    labels: {
      rotate: 0,
    },
  },
  yaxis: {
    title: {
      text: '',
    },
    labels: {
      formatter: function (a: any) {
        return formatPrice(a, 'en-US', {
          currency: 'USD',
          style: 'currency',
          minimumFractionDigits: 0,
        });
      },
    },
  },
};

const CompensationTab = () => {
  return (
    <div className="pt-11">
      <Row>
      <h5>Compensation</h5>
      </Row>
      <Row>
        <span className="text-light-grey text-fs-6 fw-light lh-xs">
        The graph below shows a breakdown of the compensation by type on an annualized basis.
        </span>
      </Row>
      <Row className="pt-11 lh-xs px-4">
        <Blockquote>
          <section>
            <Row>
              <Col className="title-span fw-bolder">
                Let's help you understand this information
              </Col>
            </Row>
            <Row>
              <Col>
                Cash Compensation is shown by calendar year. Your current year
                amount represents what you have received year-to-date plus a
                projection based on your current pay rate.
              </Col>
            </Row>
          </section>
        </Blockquote>
      </Row>
      <Row className="pt-12 px-lg-0 px-7">
        <Col className="px-0 col-12 col-lg-5">
          <ColumnsChart
            series={compensationData.series}
            options={compensationData}
          />
        </Col>
        <Col className="lh-xs pe-10 ps-lg-12 ms-lg-12">
          <SingleColumnCustomLegend
            series={compensationData.series}
            colors={compensationData.colors}
          />
          <Row className="text-fs-6 fw-light lh-xs text-ligther-grey pt-7">
            <Col>
              <span className="fw-bolder ">
                Your Year to Date W-2 Earnings:{' '}
              </span>
              $6,571
            </Col>
          </Row>

          <Row className="text-fs-6 fw-light lh-xs text-ligther-grey ">
            <Col>
              <span className="fw-bolder">Your Hourly Rate: </span> $40
            </Col>
          </Row>
          <Row className="text-fs-6 fw-light lh-xs text-ligther-grey ">
            <Col>
              <span className="fw-bolder col-lg-10">
                Your Performance Excellence Program Percentage:{' '}
              </span>{' '}
              5%
            </Col>
          </Row>
        </Col>
      </Row>
      <Row className="pt-11 mt-11 lh-xs">
        <h5>Suggestions</h5>
      </Row>
      <Row className="pt-7 lh-xs px-lg-0 px-7">
        <Blockquote>
          <section>
            <Row>
              <Col className="title-span fw-bolder">Retirement Medical</Col>
            </Row>
            <Row>
              <Col>
                Are you saving for your retirement medical needs? Consider your
                expected future cost of medical care in retirement when planning
                your financial future.
              </Col>
            </Row>
          </section>
        </Blockquote>
      </Row>
    </div>
  );
};
export default CompensationTab;
